import styled from "styled-components";

export const ParticlesWrapper = styled.aside`
    background-color: transparent;
    width: 100%;
    height: 100vh;
`;